import React, { useState } from 'react';

import { removeSchedule } from '../../../api';
import { ConfirmationDialog } from '../../../components/UIKit/ConfirmationDialog';
import { scheduleApi } from '../../../effector/schedule';

type Props = {
  id: number;
  name: string;
  onClose: () => void;
};

export const RemoveScheduleDialog: React.FC<Props> = ({ id, name, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (!loading) {
      setError('');
      onClose();
    }
  };

  const handleError = (result: { success: boolean; errorMessage?: string | null }) => {
    if (result && result.success) {
      scheduleApi.remove(id);
      onClose();
      return;
    }

    setError(result?.errorMessage ?? 'Произошла ошибка на сервере');
    setLoading(false);
  };

  const onConfirm = () => {
    setLoading(true);
    setError('');

    removeSchedule(id.toString())
      .then(handleError)
      .catch((e) => {
        setError(e.toString());
        setLoading(false);
      });
  };

  return (
    <ConfirmationDialog
      title="Удаление расписания"
      description={`Вы уверены, что хотите удалить расписание для "${name}"?`}
      error={error}
      isLoading={loading}
      onConfirm={onConfirm}
      onClose={handleClose}
    />
  );
};
